<app-popup-layout #modal>
  <div class="container model" [formGroup]="form">
    <div class="row">
      <div class="col-sm-12 col-md-12 text-center">
        <p class="title">Create New Fraud Rule</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex flex-col">
          <label class="input-label m-0">Rule ID</label>
          <input
            class="px-3"
            type="text"
            placeholder="Rule ID"
            class="form-control"
            formControlName="ruleId"
            disabled
          />
        </div>
      </div>

      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex flex-col">
          <label class="input-label m-0">Type</label>
          <select class="px-3 form-override" formControlName="type">
            <option value="" disabled selected>Select an option</option>
            <option value="Fraud Risk">Fraud Risk</option>
            <option value="Authorisation">Authorisation</option>
          </select>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex flex-col">
          <label class="input-label m-0">Condition</label>
          <input
            class="px-3"
            type="text"
            placeholder="Condition"
            class="form-control"
            formControlName="condition"
          />
        </div>
      </div>

      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex flex-col">
          <label class="input-label m-0">Action</label>
          <select class="px-3 form-override" formControlName="action">
            <option value="" disabled selected>Select an option</option>
            <option value="Approve">Approve</option>
            <option value="Decline">Decline</option>
          </select>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 mb-4">
        <div class="d-flex flex-col">
          <label class="input-label m-0">Remarks</label>
          <input
            class="px-3"
            type="text"
            placeholder="Remarks"
            class="form-control"
            formControlName="remarks"
          />
        </div>
      </div>

      <div class="col-sm-12 col-md-12">
        <div class="d-flex flex-col">
          <label class="input-label m-0">Notification Medium</label>
          <div>
            <mat-checkbox class="me-4" formControlName="email">
              Email
            </mat-checkbox>
            <mat-checkbox formControlName="sMS"> SMS </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="row combine my-8">
      <div class="col-sm-12 col-md-12 text-center">
        <button
          mat-flat-button
          color="accent"
          class="me-4"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>

        <button
          mat-flat-button
          color="primary"
          (click)="modal.close(form.value)"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</app-popup-layout>
